import { useEffect } from 'react';

import { Modal, Space, Typography } from 'antd';

import { MODAL_WIDTHS } from '@/shared/lib/constants';

import { useAuthStore } from '@/entities/auth';

import { redirectToSSOLogin } from '@/features/auth/lib';
import { IS_DEMO_APP_MODE } from '@/features/auth/lib/demoAuth';
import { LoginFormField } from '@/features/auth/ui/LoginFormField';
import { SSOButton } from '@/features/auth/ui/SSOButton';

import styles from './DirectLoginModal.module.css';

const { Title } = Typography;

type DirectLoginModalProps = {
  open: boolean;
  onCancel?: () => void;
};

export const DirectLoginModal: React.FC<DirectLoginModalProps> = ({ open, onCancel }) => {
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (IS_DEMO_APP_MODE || !open || isAuthenticated) {
      return;
    }

    redirectToSSOLogin();
  }, [open, isAuthenticated]);

  const renderDemoBody = (
    <>
      <Title level={2} className={styles.title}>
        cyclone
      </Title>
      <LoginFormField />
    </>
  );

  const renderProductionBody = (
    <>
      <Title level={2} className={styles.title}>
        cyclone
      </Title>
      <SSOButton>SSO 로그인</SSOButton>
    </>
  );

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={MODAL_WIDTHS.CONFIRM_ALERT}
      closable={false}
      maskClosable={false}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        {IS_DEMO_APP_MODE ? renderDemoBody : renderProductionBody}
      </Space>
    </Modal>
  );
};
